/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { Text } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';

import { logoutAndSetClientApp } from 'id-api/auth';
import { useChallengeCookie } from 'id-utils/login';
import { FormCard } from 'id-components/FormCard';

export namespace ClientAppNotFoundPage {
  export interface Props {}
}

export const styles = StyleSheet.create({
  spacer: {
    marginBottom: 12,
  },
});

export const ClientAppNotFoundPage: React.FC<ClientAppNotFoundPage.Props> = () => {
  const [errMessage, setErrMessage] = useState<string>('');

  const challengeCookieResult = useChallengeCookie();

  const notFoundClientAppId = (() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('clientAppId');
  })();

  const logOutHandler = async () => {
    if (!notFoundClientAppId) {
      setErrMessage('There was a problem while logging out.');
      return;
    }
    await logoutAndSetClientApp(notFoundClientAppId);
    // reloading the app so that meContext is refreshed and user is directed to UnauthenticatedApp
    window.location.reload();
  };

  return (
    <FormCard
      headerLabel={
        <div>
          <div className={css(styles.spacer)}>
            <Text>
              You are trying to access an application, "{notFoundClientAppId}", that is not available to your current
              user, "{challengeCookieResult.cookie?.username}".
            </Text>
          </div>
          <div className={css(styles.spacer)}>
            <Text>
              If you want to try logging into this application, you can click "Log Out" below and try logging in with
              another user.
            </Text>
          </div>
        </div>
      }
      headerTitle="Not Found"
      id="it-ClientAppNotFound-FormCard"
      onSubmit={logOutHandler}
      submitLabel="Log Out"
      cancelLabel="Go Back"
      errorMessage={errMessage}
    />
  );
};
